export const _loadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = () => resolve(1);
    img.onerror = () => reject();
  });
};
export const loadImage = async (src) => {
  try {
    return await _loadImage(src);
  } catch (e) {
    return -1;
  }
};

export const loadScripts = async (data) => {
  if(!data) return;
  const div = document.createElement("div");
  div.innerHTML = data;
  div.querySelectorAll("script").forEach(async (s) => {
    if (s.src) loadJs(s.src);
    else {
      const js = document.createElement("script");
      js.innerHTML = s.innerHTML;
      js.setAttribute("type", "text/javascript");
      document.head.appendChild(js);
    }
  });
  div.remove();
};

export const loadJs = (url, id) => {
  return new Promise((resolve, reject) => {
    if (document.getElementById(id)) return resolve(true);
    const js = document.createElement("script");
    js.setAttribute("id", id);
    js.setAttribute("src", url);
    js.setAttribute("type", "text/javascript");
    js.setAttribute("async", "true");
    js.onload = () => resolve(true);
    js.onerror = () => reject(false);
    document.head.appendChild(js);
  });
};
export const loadCss = async (url, id) => {
  /*
  return new Promise(async (resolve, reject) => {
    if (document.getElementById(id)) return resolve();
    const res = await fetch(url);
    const style = await res.text();
    const blob = new Blob([style], { type: "text/css" });
    const href = URL.createObjectURL(blob);
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.id = id;
    document.head.appendChild(link);
    resolve(true);
  });
  //*/
  //*
  return new Promise(async (resolve, reject) => {
    if (document.getElementById(id)) return resolve(true);
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = url;
    link.id = id;
    link.media = "all";
    link.onload = () => resolve(true);
    link.onerror = () => reject(false);
    document.head.appendChild(link);
  });
  //*/
};
